import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { EnquiryIdContainer } from "./EnquiryId.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import "../../EnquiryList.scss";

const EnquiryId = (props) => {
  const { t, data, id, isActive, siteId } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive ? 1 : "0.2"}>
        <EnquiryIdContainer>
          <Link
            to={`/site/view/${siteId}/enquiry-view-${id}`}
            className="enquiry-listin__enquiry-list-link"
          >
            {data}
          </Link>
        </EnquiryIdContainer>
      </DivBackgroundOpacity>
    </>
  );
};

EnquiryId.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(EnquiryId);
